import { Input, Output, OnInit, Directive, HostListener, EventEmitter, Renderer, Renderer2, ElementRef, AfterViewInit, forwardRef, Attribute } from '@angular/core';
import { UserRolesService } from '../user-roles.service';
import { CommonService } from '../common.service';
import { ToastService } from '../toast.service';

@Directive({
    selector: '[appUserRoles]',
    providers: [UserRolesService]
})
export class UserRolesDirective implements OnInit {

    userRoles = this.common.getUserInfo();

    @Input() name: string;
    @Input() value: string;
    @HostListener('click', ['$event'])
    onClick() {
        if (this.userRoles[this.name] == "R" || this.userRoles[this.name] == "H") {
            this.toast.warning(this.common.dontHaveRights);
            return;
        }
    };

    constructor(private renderer: Renderer2, private elementRef: ElementRef, private userRolesService: UserRolesService, private common: CommonService, private toast: ToastService) {

    }
    ngOnInit() {
        this.condition();
        if (document.getElementById(this.id)) {
            document.getElementById(this.id).onclick = () => {
                this.toast.warning(this.common.dontHaveRights);
            };
        };
    }
    id;
    condition() {
        if (this.userRoles[this.name] == "R" || this.userRoles[this.name] == "H") {
            let el: HTMLElement = this.elementRef.nativeElement;
            let innerHtml = this.elementRef.nativeElement.innerHTML;
            let tag = this.elementRef.nativeElement.localName;
            let className = this.elementRef.nativeElement.className;
            this.id = '_' + Math.random().toString(36).substr(2, 9);
            let replace = "<" + tag + " " + "id='" + this.id + "' class=' check " + className + " disable-tag-hide'>" + innerHtml + "</" + tag + ">";
            this.elementRef.nativeElement['outerHTML'] = replace;
        } else {
        }
    }

}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/ARES-admin-frontend/src/app/common/directives/user-roles.directive.ts